import { getNormalisedUrl, gtmPush } from "./helpers";

function interactionTracking() {
    // 1. Card Tracking
    // View: http://localhost:8080/page-home.html for testing
    function cardTracking() {
        const cardsEl = document.querySelectorAll(".cards-articles__item");

        // check if cardsEl has cards
        if (!cardsEl.length) return;

        // loop over cardsEl and pass in function as a param
        cardsEl.forEach(clickedCard);

        function clickedCard(card) {
            // Safety check: ensure card exists
            if (!card) return;

            // Prevent duplicate listeners on the card itself
            if (card.dataset.cardTracked) return;
            card.dataset.cardTracked = "true";

            // Get all a tags within this card
            const links = card.querySelectorAll("a");

            if (!links.length) return; // stop if there are no a tags

            // Track clicks on each link
            links.forEach((link) => {
                // Prevent duplicate listeners
                if (link.dataset.cardLinkTracked) return;
                link.dataset.cardLinkTracked = "true";

                link.addEventListener("click", (e) => {
                    // Don't track if the click was on a bookmark button
                    const clickedElement = e.target;
                    const isBookmarkButton =
                        clickedElement.closest(
                            ".bookmark_button, .bookmark",
                        ) !== null;
                    if (isBookmarkButton) return;

                    // Stop event propagation to prevent duplicate tracking
                    e.stopPropagation();

                    // Safety check: ensure card still exists when clicked
                    if (!card) return;

                    // get the text and the url
                    const titleEl = card.querySelector(".article__title");
                    const cardTextRaw = titleEl?.textContent?.trim() || "";
                    const cardText =
                        cardTextRaw.replace(/\s+/g, " ").trim() || "";
                    const cardUrl = link.getAttribute("href") || "";

                    // Track if we have either text or URL (don't require both)
                    if (cardText || cardUrl) {
                        gtmPush({
                            event: "interaction_click",
                            component_name: "card",
                            click_text:
                                cardText ||
                                link.textContent?.trim() ||
                                "Article",
                            click_url: getNormalisedUrl(cardUrl),
                        });
                    }
                });
            });
        }

        // Video Card Tracking
        const videoCardsEl = document.querySelectorAll(".video-articles__item");

        // check if videoCardsEl has cards
        if (!videoCardsEl.length) return;

        // loop over videoCardsEl and track clicks on video-article__link
        videoCardsEl.forEach(clickedVideoCard);

        function clickedVideoCard(card) {
            // Prevent duplicate listeners on the card itself
            if (card.dataset.videoCardTracked) return;
            card.dataset.videoCardTracked = "true";

            // Get all video-article__link elements within this card (there can be 2)
            const videoLinks = card.querySelectorAll(".video-article__link");

            if (!videoLinks.length) return;

            // Track clicks on each link
            videoLinks.forEach((link) => {
                // Prevent duplicate listeners
                if (link.dataset.videoLinkTracked) return;
                link.dataset.videoLinkTracked = "true";

                link.addEventListener("click", (e) => {
                    // Don't track if the click was on a bookmark button
                    const clickedElement = e.target;
                    const isBookmarkButton =
                        clickedElement.closest(
                            ".bookmark_button, .bookmark",
                        ) !== null;
                    if (isBookmarkButton) return;

                    // Stop event propagation to prevent duplicate tracking
                    e.stopPropagation();

                    // get the text from video-article__title
                    const cardTextRaw =
                        card
                            .querySelector(".video-article__title")
                            ?.textContent?.trim() || "";
                    const cardText =
                        cardTextRaw.replace(/\s+/g, " ").trim() || "";
                    const cardUrl = link.getAttribute("href") || "";

                    // Track if we have either text or URL (don't require both)
                    if (cardText || cardUrl) {
                        gtmPush({
                            event: "interaction_click",
                            component_name: "card",
                            click_text:
                                cardText || link.textContent?.trim() || "Video",
                            click_url: getNormalisedUrl(cardUrl),
                        });
                    }
                });
            });
        }

        // Rec Card Tracking (includes rec-card and rec-card-hero)
        const recCardEl = document.querySelectorAll(
            ".rec-card, .rec-card-hero",
        );

        // check if recCardEl has cards
        if (!recCardEl.length) return;

        // loop over recCardEl and track clicks on rec-card__link and rec-card-hero__link
        recCardEl.forEach(clickedRecCard);

        function clickedRecCard(card) {
            // Prevent duplicate listeners on the card itself
            if (card.dataset.recCardTracked) return;
            card.dataset.recCardTracked = "true";

            // Get all rec-card__link and rec-card-hero__link elements within this card
            const recCardLinks = card.querySelectorAll(
                ".rec-card__link, .rec-card-hero__link",
            );

            if (!recCardLinks.length) return;

            // Track clicks on each link
            recCardLinks.forEach((link) => {
                // Prevent duplicate listeners on the link
                if (link.dataset.recCardLinkTracked) return;
                link.dataset.recCardLinkTracked = "true";

                link.addEventListener("click", (e) => {
                    // Don't track if the click was on a bookmark button
                    const clickedElement = e.target;
                    const isBookmarkButton =
                        clickedElement.closest(
                            ".bookmark_button, .bookmark",
                        ) !== null;
                    if (isBookmarkButton) return;

                    // Stop event propagation to prevent parent element tracking
                    e.stopPropagation();

                    // get the text from rec-card__title or rec-card-hero__title
                    const cardTextRaw =
                        card
                            .querySelector(
                                ".rec-card__title, .rec-card-hero__title",
                            )
                            ?.textContent?.trim() || "";
                    const cardText =
                        cardTextRaw.replace(/\s+/g, " ").trim() || "";
                    const cardUrl = link.getAttribute("href") || "";

                    // Track if we have either text or URL (don't require both)
                    if (cardText || cardUrl) {
                        gtmPush({
                            event: "recommendation_interaction",
                            interaction_type: "click",
                            component_name: "rec-card",
                            click_text:
                                cardText ||
                                link.textContent?.trim() ||
                                "Read recommendation",
                            click_url: getNormalisedUrl(cardUrl),
                        });
                    }
                });
            });
        }
    }

    // 2. Pre-Footer Links Tracking
    // View: http://localhost:8080/page-home.html for testing
    function prefooterTracking() {
        const prefooterEL = document.querySelector(".pre-footer__container");
        // stop if not prefooterEL exists
        if (!prefooterEL) return;

        const prefooterLinks = prefooterEL.querySelectorAll(
            ".pre-footer__link a",
        );
        // stop if no prefooterLinks
        if (!prefooterLinks.length) return;

        // loop over links and pass in function as a param
        prefooterLinks.forEach(clickedPreFooter);

        function clickedPreFooter(link) {
            // Prevent duplicate listeners
            if (link.dataset.prefooterTracked) return;
            link.dataset.prefooterTracked = "true";

            link.addEventListener("click", (e) => {
                // Stop event propagation to prevent duplicate tracking
                e.stopPropagation();

                // get text and link
                const linkTextRaw = link.textContent?.trim() || "";
                const linkText = linkTextRaw.replace(/\s+/g, " ").trim() || "";
                const linkUrl = link.getAttribute("href") || "";

                // Track if we have either text or URL
                if (linkText || linkUrl) {
                    gtmPush({
                        event: "interaction_click",
                        component_name: "pre-footer link",
                        click_text: linkText || "Link",
                        click_url: getNormalisedUrl(linkUrl),
                    });
                }
            });
        }
    }

    // 3. Pre-footer CTA Panel
    // View: http://localhost:8080/page-home.html for testing
    function prefooterPanel() {
        const preFooterPanelContainer = document.querySelector(
            ".pre-footer__panel-container",
        );

        if (!preFooterPanelContainer) return;

        const panelButtons = preFooterPanelContainer.querySelectorAll(
            ".pre-footer__panel-button",
        );

        if (!panelButtons.length) return;

        panelButtons.forEach((button) => {
            if (!button) return;

            // Prevent duplicate listeners
            if (button.dataset.prefooterPanelTracked) return;
            button.dataset.prefooterPanelTracked = "true";

            button.addEventListener("click", (e) => {
                const clickedElement = e.target;
                const isButtonClick =
                    clickedElement === button ||
                    clickedElement.closest(".pre-footer__panel-button") ===
                        button;

                if (!isButtonClick) return;

                // Stop event propagation to prevent duplicate tracking
                e.stopPropagation();

                const linkTextRaw = button.textContent?.trim() || "";
                const linkText = linkTextRaw.replace(/\s+/g, " ").trim() || "";
                const linkUrl = button.getAttribute("href") || "";

                // Track if we have either text or URL
                if (linkText || linkUrl) {
                    gtmPush({
                        event: "interaction_click",
                        component_name: "pre-footer cta panel",
                        click_text: linkText || "Button",
                        click_url: getNormalisedUrl(linkUrl),
                    });
                }
            });
        });
    }

    // 4. Banner Tracking
    // View: http://localhost:8080/page-home.html for testing
    function bannerTracking() {
        const banner = document.querySelector(".banner");

        if (!banner) return;

        const bannerButton = banner.querySelector(
            ".button.button--large.button--primary.banner__cta-button",
        );

        if (!bannerButton) return;

        // Prevent duplicate listeners
        if (bannerButton.dataset.bannerTracked) return;
        bannerButton.dataset.bannerTracked = "true";

        bannerButton.addEventListener("click", (e) => {
            const clickedElement = e.target;
            const isButtonClick =
                clickedElement === bannerButton ||
                clickedElement.closest(
                    ".button.button--large.button--primary.banner__cta-button",
                ) === bannerButton;

            if (!isButtonClick) return;

            // Stop event propagation to prevent duplicate tracking
            e.stopPropagation();

            const linkTextRaw = bannerButton.textContent?.trim() || "";
            const linkText = linkTextRaw.replace(/\s+/g, " ").trim() || "";
            const linkUrl = bannerButton.getAttribute("href") || "";

            // Track even if linkText is empty, as long as we have a URL
            if (linkUrl) {
                gtmPush({
                    event: "interaction_click",
                    component_name: "banner",
                    click_text: linkText || "Start Senior Road User Quiz",
                    click_url: getNormalisedUrl(linkUrl),
                });
            }
        });
    }

    // 5. inline-CTA
    // View: http://localhost:8080/page-home.html for testing
    function inlineCtaTracking() {
        const inlineCtaWrapper = document.querySelector(".inline-cta__wrapper");

        if (!inlineCtaWrapper) return;

        const inlineCtaButton = inlineCtaWrapper.querySelector(
            ".button.button--large.inline-cta__button",
        );

        if (!inlineCtaButton) return;

        // Prevent duplicate listeners
        if (inlineCtaButton.dataset.inlineCtaTracked) return;
        inlineCtaButton.dataset.inlineCtaTracked = "true";

        inlineCtaButton.addEventListener("click", (e) => {
            const clickedElement = e.target;
            const isButtonClick =
                clickedElement === inlineCtaButton ||
                clickedElement.closest(
                    ".button.button--large.inline-cta__button",
                ) === inlineCtaButton;

            if (!isButtonClick) return;

            // Stop event propagation to prevent duplicate tracking
            e.stopPropagation();

            const linkTextRaw = inlineCtaButton.textContent?.trim() || "";
            const linkText = linkTextRaw.replace(/\s+/g, " ").trim() || "";
            const linkUrl = inlineCtaButton.getAttribute("href") || "";

            // Track if we have either text or URL
            if (linkText || linkUrl) {
                gtmPush({
                    event: "interaction_click",
                    component_name: "button",
                    click_text: linkText || "Button",
                    click_url: getNormalisedUrl(linkUrl),
                });
            }
        });
    }

    // 6. video Article Tracking
    function videoBtnTracking() {
        const playButtons = document.querySelectorAll(
            "button.icon-video-control",
        );

        const transcriptButtons = document.querySelectorAll(
            "button.video-article__description--transcript-button",
        );

        playButtons.forEach((button) => {
            // Prevent duplicate listeners
            if (button.dataset.videoBtnTracked) return;
            button.dataset.videoBtnTracked = "true";

            button.addEventListener("click", (e) => {
                // Stop event propagation to prevent duplicate tracking
                e.stopPropagation();

                // Get the slide that contains this button
                const slide = button.closest(".swiper-slide");

                const inlineVideoContainer = button.closest(
                    ".accordion:has(.banner--inline-video)",
                );

                const testimonialContainer = button.closest(
                    ".banner--testimonial",
                );

                // Only track if the slide is active for a video carousel
                // OR if an inline video or testimonial
                if (
                    (slide &&
                        slide.classList.contains("swiper-slide-active")) ||
                    inlineVideoContainer ||
                    testimonialContainer
                ) {
                    const articleTitle = slide
                        ? slide
                              .querySelector(".video-article__title")
                              ?.textContent?.trim()
                        : inlineVideoContainer
                              ?.querySelector(".accordion__button")
                              ?.textContent?.trim() ||
                          testimonialContainer
                              ?.querySelector(".banner__title")
                              ?.textContent?.trim();
                    const actionText = button.getAttribute("aria-label");

                    // Use setTimeout to ensure the toggle has completed
                    setTimeout(() => {
                        // add to gtm
                        gtmPush({
                            event: "interaction_click",
                            component_name: "button",
                            click_text: `${actionText} Video: ${articleTitle}`,
                            click_url: null,
                        });
                    }, 10);
                }
            });
        });

        transcriptButtons.forEach((button) => {
            if (!button) return;

            // Prevent duplicate listeners
            if (button.dataset.videoBtnTracked) return;
            button.dataset.videoBtnTracked = "true";

            button.addEventListener("click", (e) => {
                // Stop event propagation to prevent duplicate tracking
                e.stopPropagation();

                // Get the slide that contains this button
                const slide = button.closest(".swiper-slide");

                // Only track if the slide is active
                if (slide && slide.classList.contains("swiper-slide-active")) {
                    const articleTitle = slide
                        .querySelector(".video-article__title")
                        ?.textContent?.trim();

                    // Get the button text BEFORE the toggle happens
                    // Check the current state to determine the action
                    const isCurrentlyOpen =
                        button.getAttribute("aria-expanded") === "true";

                    // If currently closed, the click will open it (Read Transcript)
                    // If currently open, the click will close it (Close)
                    const actionText = isCurrentlyOpen
                        ? "Close Transcript"
                        : "Read Transcript";

                    // Use setTimeout to ensure the toggle has completed
                    setTimeout(() => {
                        // add to gtm
                        gtmPush({
                            event: "interaction_click",
                            component_name: "button",
                            click_text: `${actionText}: ${articleTitle}`,
                            click_url: null,
                        });
                    }, 10);
                }
            });
        });
    }

    // 6. Accordion Tracking
    function accordionTracking() {
        // Get all accordion elements
        const accordions = document.querySelectorAll(".accordion");

        if (!accordions.length) return;

        accordions.forEach((accordion) => {
            const header = accordion.querySelector(".accordion__header");
            if (!header) return;

            const button = header.querySelector(".accordion__button");
            if (!button) return;

            // Prevent duplicate listeners
            if (header.dataset.accordionTracked) return;
            header.dataset.accordionTracked = "true";

            // CLICK tracking
            header.addEventListener("click", (e) => {
                // Ignore link clicks
                if (e.target.closest("a")) return;

                // The Accordion class will handle the toggle and aria update
                // We track after a small delay to ensure the toggle has completed
                setTimeout(() => {
                    const isNowExpanded =
                        button.getAttribute("aria-expanded") === "true";
                    const buttonText = button.textContent?.trim() || "";

                    gtmPush({
                        event: "interaction_click",
                        component_name: "Accordion",
                        component_element: buttonText,
                        interaction_type: isNowExpanded ? "expand" : "collapse",
                    });
                }, 10);
            });
        });
    }

    // 7. Tabs Tracking
    function tabsTracking() {
        // Get all tab list link button elements
        const tabButtons = document.querySelectorAll("button.tabs__list-link");
        const seeAllLinks = document.querySelectorAll(
            ".resources-button, .resources-seeall__link",
        );

        tabButtons.forEach((button) => {
            // Prevent duplicate listeners
            if (button.dataset.tabsTracked) return;
            button.dataset.tabsTracked = "true";

            // CLICK tracking
            button.addEventListener("click", (e) => {
                // The Tabs component will handle the selection and aria update
                // We track after a small delay to ensure the toggle has completed
                setTimeout(() => {
                    const isNowSelected =
                        button.getAttribute("aria-selected") === "true";
                    const buttonText = button.textContent?.trim() || "";

                    gtmPush({
                        event: "interaction_click",
                        component_name: "Tabs",
                        component_element: buttonText,
                        interaction_type: "select",
                    });
                }, 10);
            });
        });

        seeAllLinks.forEach((link) => {
            // Prevent duplicate listeners
            if (link.dataset.linkTracked) return;
            link.dataset.linkTracked = "true";

            // CLICK tracking
            link.addEventListener("click", (e) => {
                const linkText =
                    link.textContent.replace(/\s+/g, " ").trim() || "";
                const linkUrl = link.getAttribute("href") || "";

                if (linkText && linkUrl) {
                    gtmPush({
                        event: "interaction_click",
                        component_name: "link",
                        click_text: linkText,
                        click_url: getNormalisedUrl(linkUrl),
                    });
                }
            });
        });
    }

    // 8. Article Tracking
    function articleTracking() {
        // Get NodeLists
        const articleContentLinks = document.querySelectorAll(
            ".article-block__content a",
        );
        const articleRelatedLinks = document.querySelectorAll(
            ".article-block__related-link",
        );

        // Combine both NodeLists into one array
        const allArticleLinks = [
            ...(articleContentLinks || []),
            ...(articleRelatedLinks || []),
        ];

        if (!allArticleLinks.length) return; // exit early if no links

        allArticleLinks.forEach((link) => {
            if (!link) return;

            // Prevent duplicate listeners
            if (link.dataset.articleLinkTracked) return;
            link.dataset.articleLinkTracked = "true";

            link.addEventListener("click", () => {
                // For related links, get text from the nested span if it exists
                let linkTextRaw = "";
                if (link.classList.contains("article-block__related-link")) {
                    const textSpan = link.querySelector(
                        ".article-block__related-link-text",
                    );
                    linkTextRaw = textSpan?.textContent?.trim() || "";
                } else {
                    linkTextRaw = link.textContent?.trim() || "";
                }

                const linkText = linkTextRaw.replace(/\s+/g, " ").trim() || "";
                const linkUrl = link.getAttribute("href") || "";

                if (linkText && linkUrl) {
                    gtmPush({
                        event: "interaction_click",
                        component_name: "link",
                        click_text: linkText,
                        click_url: getNormalisedUrl(linkUrl),
                    });
                }
            });
        });
    }

    // 9. Rec User Actions Tracking (Email/Share recommendations)
    function recShareTracking() {
        const recUserActions = document.querySelector(".rec-user-actions");

        if (!recUserActions) return;

        const shareButtons = recUserActions.querySelectorAll(
            ".rec-user-actions__cta-button",
        );

        if (!shareButtons.length) return;

        shareButtons.forEach((button) => {
            // Prevent duplicate listeners
            if (button.dataset.recShareTracked) return;
            button.dataset.recShareTracked = "true";

            button.addEventListener("click", (e) => {
                const clickedElement = e.target;
                const isButtonClick =
                    clickedElement === button ||
                    clickedElement.closest(".rec-user-actions__cta-button") ===
                        button;

                if (!isButtonClick) return;

                const buttonTextRaw = button.textContent?.trim() || "";
                const buttonText =
                    buttonTextRaw.replace(/\s+/g, " ").trim() || "";

                if (buttonText) {
                    gtmPush({
                        event: "recommendation_interaction",
                        component_name: "button",
                        click_text: buttonText,
                        click_url: null,
                    });
                }
            });
        });
    }

    // 10. Resource Download / Share
    function resourceShareTracking() {
        const resourceShareButtons = document.querySelectorAll(
            ".share-resource__links button",
        );

        resourceShareButtons.forEach((button) => {
            // Prevent duplicate listeners
            if (button.dataset.resourceShareTracked) return;
            button.dataset.resourceShareTracked = "true";

            button.addEventListener("click", (e) => {
                const buttonText =
                    button.textContent?.replace(/\s+/g, " ").trim() || "";

                if (buttonText) {
                    gtmPush({
                        event: "interaction_click",
                        component_name: "resource_share",
                        click_text: buttonText,
                        click_url: null,
                    });
                }
            });
        });
    }

    // Initialize tracking functions
    function initInteraction() {
        cardTracking();
        prefooterTracking();
        prefooterPanel();
        bannerTracking();
        inlineCtaTracking();
        videoBtnTracking();
        accordionTracking();
        tabsTracking();
        articleTracking();
        recShareTracking();
        resourceShareTracking();
    }

    initInteraction();
}

export default interactionTracking;
